var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details-sheet',_vm._b({attrs:{"item":_vm.request,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.customer",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]}},{key:"item.address",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.address)+"\n  ")]}}])},'details-sheet',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }